import { render } from "./BreadcrumbComponent.vue?vue&type=template&id=a1ee319e&scoped=true"
import script from "./BreadcrumbComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbComponent.vue?vue&type=script&lang=js"

import "./BreadcrumbComponent.vue?vue&type=style&index=0&id=a1ee319e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ee319e"]])

export default __exports__